import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, connect as connectFormik } from 'formik';
import { withLocalize } from 'react-localize-redux';
import { domainActions } from '../../store/domainStore';
import "./financialStatement.scss";
import SelectOption from './selectOption';
import { isNullOrUndefined } from '../../store/storeFunctions';
import DeleteIcon from '../../img/icons/BBiconsOdstranit';
import BbInput, { BbSelectNoFormik } from '../styling/bbInput';
import PopupMultiSelectButton from '../common/popupMultiSelectButton';

class FinValueRow extends React.Component {

    render() {
        if (!isNullOrUndefined(this.props.typeName)) {
            return this.renderOrganizationsRow();
        }

        return (
            <div className="columns fin-value-row">
                {this.props.financialDomainsLoaded &&
                    <>
                        <div className="column is-6">
                            <div className="control">
                            <BbSelectNoFormik options={this.getConditionLabels()} formatOptionLabel={SelectOption}
                                onChange={(e) =>  {
                                    this.props.formik.setFieldValue(`financial.${this.props.field}.values[${this.props.index}].value`, e.value);
                                    this.setState({organizationType: e.value});
                                }}
                                value={this.getConditionLabel(this.props.formik.values.financial[this.props.field].values[this.props.index].value)}
                                selectPlaceholder={this.props.translate(this.props.placeholder)}
                                />
                            </div>
                        </div>
                        <div className="is-flex w-100">
                            <div className="column is-5 is-5-mobile">
                                <div className="control">
                                    <BbInput
                                        label={this.props.translate("Report.Common.From")}
                                        name={`financial.${this.props.field}.values[${this.props.index}].from`}
                                        type="number"
                                        placeholder={{ type: 'inline' }}
                                        style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "0" }}
                                    />
                                </div>
                            </div>
                            <div className="column is-5 is-5-mobile">
                                <div className="control">
                                    <BbInput
                                        label={this.props.translate("Report.Common.To")}
                                        name={`financial.${this.props.field}.values[${this.props.index}].to`}
                                        type="number"
                                        placeholder={{ type: 'inline' }}
                                        style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "0" }}
                                    />
                                </div>
                            </div>
                            <div className="column is-2 is-2-mobile">
                                <div className="icon-wrapper">
                                    <div className="fin-button remove">
                                    <DeleteIcon className="icon-centered svg-standard-fill" onClick={() => this.removeValue(this.props.index, this.props.field) }></DeleteIcon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}
            </div>
        )
    }  

    changeOrganizationsValue = (e) => {
        let organizationValues = this.props.formik.values.financial.organizationsValues.values;
        let currentVal = organizationValues[this.props.typeName].value[this.props.index];
        organizationValues[this.props.typeName].value[this.props.index] = {value: e.value, from: currentVal.from, to: currentVal.to}
        this.props.formik.setFieldValue(`financial.organizationsValues.values`, organizationValues);
    }

    changeOrganizationValue =(type, value, e) => {
        let organizationValues = this.props.formik.values.financial.organizationsValues.values;
        let currentVal = organizationValues[this.props.typeName].value[this.props.index];
        //Change value
        if (type === "from")
            organizationValues[this.props.typeName].value[this.props.index] = {value: currentVal.value, from: value, to: currentVal.to}

        if (type === "to")  
            organizationValues[this.props.typeName].value[this.props.index] = {value: currentVal.value, from: currentVal.from, to: value}

        this.props.formik.setFieldValue(`financial.organizationsValues.values`, organizationValues);
        e.stopPropagation();
    }

    onFromValueChanged = (e) => this.changeOrganizationValue("from", e.currentTarget.value, e);
    onToValueChanged = (e) => this.changeOrganizationValue("to", e.currentTarget.value, e);

    renderOrganizationsRow = () => {
        return  this.props.financialDomainsLoaded &&<> <div className="columns fin-value-row">

                <div className="column is-6">
                    <div className="control">
                        <div className="field bb-field">
                            <div className="control">
                                <BbSelectNoFormik options={this.getConditionLabels()} formatOptionLabel={SelectOption}
                                    onChange={this.changeOrganizationsValue}
                                    value={this.getConditionLabel(this.props.formik.values.financial['organizationsValues'].values[this.props.typeName].value[this.props.index].value)}
                                    selectPlaceholder={this.props.translate(this.props.placeholder)}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="is-flex w-100">
                    <div className="column is-5 is-5-mobile">
                        <div className='control'>
                            <div className="field bb-field">
                                <div className="control">
                                <Field
                                    value={this.props.formik.values.financial.organizationsValues.values[this.props.typeName].value[this.props.index].from}
                                    type="number"
                                    name={"from"}
                                    onChange={this.onFromValueChanged}
                                    placeholder={this.props.translate("Report.Common.From")}
                                    className="input form-control"
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column is-5 is-5-mobile">
                        <div className="control">
                        <div className="field bb-field">
                                <div className="control">
                                <Field
                                    value={this.props.formik.values.financial.organizationsValues.values[this.props.typeName].value[this.props.index].to}
                                    type="number"
                                    name={"to"}
                                    onChange={this.onToValueChanged}
                                    placeholder={this.props.translate("Report.Common.To")}
                                    className="input form-control"
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column is-2 is-2-mobile">
                        <div className="icon-wrapper">
                            <div className="fin-button remove">
                            <DeleteIcon className="icon-centered svg-standard-fill" onClick={() => this.removeValueFromOrganizations(this.props.index) }></DeleteIcon>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </>
    }

    getConditionLabel(value) {
        if (isNullOrUndefined(value) || value === "")
            return null;

        let x = this.getConditionLabels().find(f => f.value === value);
        return isNullOrUndefined(x) ? null : x;
    }

    getConditionLabels() {
        let cond = [];
        if (this.props.domain === "fin-statement-values" || this.props.domain === "fin-statement-values-ifrs" || this.props.domain === "fin-statement-values-ifrs-original") {
            if (this.props[this.props.domain].requestResult) {
                cond.push(...this.props[this.props.domain].requestResult.filter(x => x.order !== 0).sort((a, b) => a.order > b.order ? 1 : -1).map((f, i) => {
                    return { key: i + 1, value: f.value, label: f.label }
                }))
            }
        } else if (this.props.domain === "fin-statement-ratios") {
            if (this.props[this.props.domain].requestResult) {
                cond.push(...this.props[this.props.domain].requestResult.filter(x => x.extra.UseFlag >= 1).sort((a, b) => a.order > b.order ? 1 : -1).map((f, i) => {
                    return { key: i + 1, value: f.value, label: f.label }
                }))
            }
        } else {
            if (this.props[this.props.domain].requestResult) {
                cond.push(...this.props[this.props.domain].requestResult.map((f, i) => {
                    return { key: i + 1, value: f.value, label: f.label }
                }))
            }
        }

        return cond;
    }

    removeValue = (index, field) => {
        this.props.formik.setFieldValue(`financial.${field}.values`, this.props.formik.values.financial[field].values.filter((_, i) => i !== index));
    }

    removeValueFromOrganizations = (index) => {
        let organizationValues = this.props.formik.values.financial.organizationsValues.values;   
        let currentArray = organizationValues[this.props.typeName].value;
        currentArray.splice(index, 1);

        organizationValues[this.props.typeName].value = currentArray;
        this.props.formik.setFieldValue(`financial.organizationsValues.values`, organizationValues);
    }
}
export default withLocalize(connectFormik(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch),
)(FinValueRow)));
